import { PulseEvent, PulseEventMessage, TransformPipe } from '@pulse/common';

interface CustomEvent extends Partial<PulseEvent> {
    action?: string;
    parameters?: Record<string, unknown>;
}

/**
 * Add support for events with action/parameter structure.
 * ```
 * { action: 'event_name', parameters: { ...data } }
 * ```
 */
export class ActionParamEventPipe implements TransformPipe<PulseEventMessage> {
    transform(message: PulseEventMessage): PulseEventMessage[] {
        const event: CustomEvent = { ...message.data };

        if (
            (typeof event.event !== 'string' || !event.event) &&
            typeof event.action === 'string' &&
            event.action
        ) {
            event.event_type = event.action;
            delete event.action;
        } else {
            event.event_type = event.event || event.event_type;
            delete event.event;
        }

        if (typeof event.data !== 'object' || !event.data) {
            if (typeof event.parameters === 'object' && event.parameters) {
                event.data = event.parameters;
                delete event.parameters;
            } else {
                event.data = {};
            }
        }

        message.data = event as PulseEvent;

        return [message];
    }
}
